import Image from 'next/image'
import React from 'react'

interface Props {
  venueLogo: any
}

export const VenueLogo = ({ venueLogo }: Props) => {
  if (!venueLogo) {
    return null
  }

  return (
    <div className="absolute bottom-0 flex w-full justify-start px-4 pb-9">
      <div className="relative flex h-[58px] w-[80px] justify-center overflow-hidden rounded-xl bg-surface-ui-background shadow-xl">
        <Image
          fill
          priority
          alt="Venue logo"
          className="object-contain p-0.5"
          src={venueLogo.originalImageUrl}
          sizes="80px"
        />
      </div>
    </div>
  )
}
